import React from "react";

import { Box } from "@mui/material";
import type { CardConfig, DataFreshnessCardConfig, DataFreshnessTimeRange } from "store/types";

import { RadioRow } from "./RadioRow";
import { SectionLabel } from "./SectionLabel";

interface Props {
  config: DataFreshnessCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

const TIME_RANGE_OPTIONS: [DataFreshnessTimeRange, string][] = [
  ["month", "Monthly"],
  ["quarter", "Quarterly"],
  ["year", "Annual"]
];

export const DataFreshnessSettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  const selected = config.timeRange ?? "month";

  return (
    <Box>
      <SectionLabel>Time Range</SectionLabel>
      {TIME_RANGE_OPTIONS.map(([value, label]) => (
        <RadioRow
          key={value}
          label={label}
          selected={selected === value}
          onChange={() => onUpdateConfig({ ...config, timeRange: value })}
        />
      ))}
    </Box>
  );
};
